(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('CompanySubscriptionStatusDetailController', CompanySubscriptionStatusDetailController);

    CompanySubscriptionStatusDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'CompanySubscriptionStatus', 'MoneyTransferLog', 'SubscriptionPackage', 'Company'];

    function CompanySubscriptionStatusDetailController($scope, $rootScope, $stateParams, entity, CompanySubscriptionStatus, MoneyTransferLog, SubscriptionPackage, Company) {
        var vm = this;

        vm.companySubscriptionStatus = entity;

        var unsubscribe = $rootScope.$on('tikonApp:companySubscriptionStatusUpdate', function (event, result) {
            vm.companySubscriptionStatus = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
